import { bootstrapTokenFromUrl } from "../../core/session/bootstrap";
import React from 'react';
import ReactDOM from 'react-dom';
import Public from './Publico';

bootstrapTokenFromUrl();

ReactDOM.render(<Public />, document.getElementById('app'));
